import apiClient from './apiClient';

export interface SendDocumentResponse {
  success: boolean;
  message: string;
  data?: {
    messageId: number;
    mediaId: number;
  };
}

export const documentService = {
  /**
   * Enviar documento para cliente
   */
  async sendDocumentToClient(
    conversationId: number,
    document: File,
    messageText?: string
  ): Promise<SendDocumentResponse> {
    const formData = new FormData();
    formData.append('document', document);
    formData.append('conversationId', conversationId.toString());
    if (messageText) {
      formData.append('messageText', messageText);
    }

    const response = await apiClient.post('/documents/send-document', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },
};

